/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum LoginLandingPageAliases {
  FOOTER_0 = 'footer-0',
  FOOTER_FRAGMENT = 'footer-fragment',
  FOOTER_PANEL = 'footer-panel',
  LANDING_PAGE_SLIDE_0 = 'landing-page-slide-0',
  LAYOUT_0 = 'layout-0',
  LAYOUT_1 = 'layout-1',
  LOGIN_LANDING_PAGE_ALERT_LOAD_MORE_BUTTON = 'login-landing-page-alert-load-more-button',
  LOGIN_LANDING_PAGE_ALERT_PANEL = 'login-landing-page-alert-panel',
  LOGIN_LANDING_PAGE_ALERT_TOAST_NOTIFICATION = 'login-landing-page-alert-toast-notification',
  LOGIN_LANDING_PAGE_BACKGROUND_PANEL = 'login-landing-page-background-panel',
  LOGIN_LANDING_PAGE_CONTENT_LAYOUT = 'login-landing-page-content-layout',
  LOGIN_LANDING_PAGE_IMAGE_LOGO = 'login-landing-page-image-logo',
  LOGIN_LANDING_PAGE_INFO_CAROUSEL = 'login-landing-page-info-carousel',
  LOGIN_LANDING_PAGE_INTERNAL_CONTENT_LAYOUT = 'login-landing-page-internal-content-layout',
  LOGIN_LANDING_PAGE_LAYOUT = 'login-landing-page-layout',
  LOGIN_LANDING_PAGE_LAYOUT_LOGO = 'login-landing-page-layout-logo',
  LOGIN_LANDING_PAGE_LAYOUT_TOP = 'login-landing-page-layout-top',
  LOGIN_LANDING_PAGE_LINK_CARD = 'login-landing-page-link-card',
  LOGIN_LANDING_PAGE_LINK_MAPPER = 'login-landing-page-link-mapper',
  LOGIN_LANDING_PAGE_LINK_PANEL = 'login-landing-page-link-panel',
  LOGIN_LANDING_PAGE_LOGIN = 'login-landing-page-login',
  LOGIN_LANDING_PAGE_LOGIN_PANEL = 'login-landing-page-login-panel',
  LOGIN_LANDING_PAGE_LOGO_TEXT = 'login-landing-page-logo-text',
  LOGIN_LANDING_PAGE_PANEL_BOARD = 'login-landing-page-panel-board',
  LOGIN_LANDING_PAGE_PANEL_TOP = 'login-landing-page-panel-top',
  LOGIN_LANDING_PAGE_SIGNIN_BUTTON = 'login-landing-page-signin-button',
  NEW_ACCOUNT_BUTTON = 'new-account-button',
  NEW_ACCOUNT_PANEL = 'new-account-panel',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  REPEATER = 'repeater',
}
export { LoginLandingPageAliases };
